module.exports = __webpack_public_path__ + "f462031997ccc849249b3ea12c9ce2a8.png";


//////////////////
// WEBPACK FOOTER
// ./js/img/gnomad.png
// module id = 1343
// module chunks = 0